import type { ReactNode } from "react";

type Props = {
  position: "top" | "bottom";
  children?: ReactNode;
  mode?: "default" | "crush" | "extreme";
};

export function Letterbox({ position, children, mode = "default" }: Props) {
  const heightVar = {
    default: "var(--letterbox-h)",
    crush: "var(--letterbox-h-crush)",
    extreme: "var(--letterbox-h-extreme)",
  }[mode];

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        left: 0,
        [position]: 0,
        width: "100%",
        height: heightVar,
        backgroundColor: "var(--ink)",
        zIndex: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 var(--space-lg)",
        borderTop:
          position === "bottom" ? "1px solid rgba(245,240,228,0.08)" : undefined,
        borderBottom:
          position === "top" ? "1px solid rgba(245,240,228,0.08)" : undefined,
        transition: "height var(--dur-long) var(--ease-crush)",
      }}
    >
      {children}
    </div>
  );
}
